import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatEvent } from "../../manager/WeChatConst";

const {ccclass, property} = cc._decorator;
/**
 * 头像
 */
@ccclass
export default class HeadImgNode extends cc.Component {

    @property({type:cc.Sprite,displayName:"头像"})
    headImgSpirit : cc.Sprite = null;
    @property({type:cc.Node,displayName:"锁Node"})
    lockNode : cc.Node = null;
    @property({type:cc.Node,displayName:"选择Node"})
    tickNode : cc.Node = null;

    @property({type:cc.Sprite,displayName:"背景板节点"})
    bgNode:cc.Sprite = null;

    @property({type:cc.SpriteFrame,displayName:"未选中的背景板"})
    notSelectSpr:cc.SpriteFrame = null;

    @property({type:cc.SpriteFrame,displayName:"选中的背景板"})
    selectSpr:cc.SpriteFrame = null;

    private mId : string;
    private mHeadUnique : string ;
    private mNeedWatchAdFlag : boolean;
    private mNormalGameManager : NormalGameManager;

    onLoad () {
        O1HD.on("HeadImgNode.chooseTick" , this.chooseTick.bind(this) , this );
    }

    start () {

    }

    /**
     *
     * @param headUnique 头像唯一标识
     * @param needWatchAdFlag 是否需要看广告标识
     */
    bindData( id: string, headUnique : string , needWatchAdFlag : boolean , normalGameManager : NormalGameManager ){
        this.mId = id;
        this.mHeadUnique = headUnique;
        this.mNeedWatchAdFlag = needWatchAdFlag;
        this.mNormalGameManager = normalGameManager;
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/user/head/${headUnique}`,cc.SpriteFrame,( error , assets : cc.SpriteFrame )=>{
            if ( error ) {
                console.log("头像加载失败",headUnique );
                return
            }
            this.headImgSpirit.spriteFrame = assets;
        });
        this.refreshAdIcon();
        // console.log( this.mId , this.mNormalGameManager.getGameData().userCurrHead );
        if ( this.mNormalGameManager.getGameData().userCurrHead == this.mId ) {
            // console.log("true")
            this.tickNode.active = true;
        }
    }

    /**
     * 刷新Ad Icon
     */
    refreshAdIcon(){
        if ( this.mNeedWatchAdFlag ){
            // 判断是否展示视频
            if ( this.mNormalGameManager.getGameData().userHeadArray.includes( this.mId ) ) {
                this.lockNode.active = false;
            }
        }else{
            this.lockNode.active = false;
        }
    }

    /**
     * 点击
     */
    onBtnClick(){
        if ( this.lockNode.active ) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                // 用户解锁头像 用户选择当前头像 更改Global数据，刷新头像事件
                this.mNormalGameManager.setGameData({userHeadArray:[this.mId]} , true );
                this.lockNode.active = false;
                O1HD.emit("HeadImgNode.chooseTick" , this.mId );
            },()=>{
                O1HD.getModules().uiControlModule.showMessageBox("视频观看失败",this.node);
            },()=>{

            });
        }else{
            // 用户选择当前头像 更改Global数据，刷新头像事件
            O1HD.emit("HeadImgNode.chooseTick" , this.mId );
        }
    }

    /**
     * 选择tick
     */
    chooseTick( headId : string ){
        if ( this.node ){
            if ( this.mId == headId ) {
                this.mNormalGameManager.setGameData({ userCurrHead:headId} , false );
                O1HD.emit(WeChatEvent.USERUPDATEHEAD);
                this.tickNode.active = true;
                this.bgNode.spriteFrame = this.selectSpr;
            }else{
                this.tickNode.active = false;
                this.bgNode.spriteFrame = this.notSelectSpr;
            }
        }
    }

}
